/**
 * 쉐어링크 붙여넣기 파서 (곳곳 sharelink-paste.ts 이식)
 * 토스 「링크 발급」이 복사해 주는 3줄을 폼 칸으로 나눈다.
 *   ✱ 이 포스팅은 … 수수료를 제공받습니다.   → description (대가성 문구)
 *   스파클 생수, 무라벨, 1L, 24개              → title (상품명)
 *   https://toss.shopping/_m/NjBQYjUj          → targetUrl
 * 줄 순서는 따지지 않는다. 주소 줄이 없으면 null — 엉뚱한 글로 칸을 덮지 않는다.
 */
const DISCLOSURE_MARK = '✱';
const SHARELINK_HOSTS = ['toss.shopping', 'toss.im'];
const SHORT_LINK_PATH = '/_m/';

export interface SharelinkPaste {
  description: string | null;
  title: string;
  targetUrl: string;
}

export const isValidSharelinkUrl = (raw: string): boolean => {
  try {
    const u = new URL(raw.trim());
    return (
      u.protocol === 'https:' &&
      SHARELINK_HOSTS.includes(u.hostname) &&
      u.pathname.startsWith(SHORT_LINK_PATH) &&
      u.pathname.length > SHORT_LINK_PATH.length
    );
  } catch {
    return false;
  }
};

export const parseSharelinkPaste = (text: string): SharelinkPaste | null => {
  const lines = text
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);

  const targetUrl = lines.find(isValidSharelinkUrl);
  if (!targetUrl) return null;

  const description = lines.find((l) => l.startsWith(DISCLOSURE_MARK)) ?? null;
  const title = lines.filter((l) => l !== targetUrl && l !== description).join(' ');
  return { description, title, targetUrl };
};
